export default __webpack_public_path__ + "static/media/qr-generation.99986571.svg";